module.exports = __webpack_public_path__ + "media/images/emblems/Turtmann-b23f34654ac4547c55b2dbd2c1d20b43.gif";